// remove when  tables for demo are created

import { EI18nLanguageUI } from '@packages/utils';
import {
  EI18nLanguageDB,
  ELanguage,
  TAddressTypesDB,
  TAddressTypesUI,
  TOption,
  TYesNoOptionType,
} from './generic.types';

export enum EEventType {
  READY_FOR_KINDERGARTEN = 'READY_FOR_KINDERGARTEN',
  READY_FOR_MATH = 'READY_FOR_MATH',
  READY_FOR_KINDERGARTEN_SOCIAL_EMOTIONAL = 'READY_FOR_KINDERGARTEN_SOCIAL_EMOTIONAL',
  LEARNING_CHILD_CARE_AND_PRESCHOOL_PROGRAMS = 'LEARNING_CHILD_CARE_AND_PRESCHOOL_PROGRAMS',
  CHILD_CARE_AND_PRESCHOOL_PROGRAMS_PART_1 = 'CHILD_CARE_AND_PRESCHOOL_PROGRAMS_PART_1',
  CHILD_CARE_AND_PRESCHOOL_PROGRAMS_PART_2 = 'CHILD_CARE_AND_PRESCHOOL_PROGRAMS_PART_2',
}

export enum EEventAgeGroup {
  ZERO_TO_ONE = 'ZERO_TO_ONE',
  ONE_TO_TWO = 'ONE_TO_TWO',
  TWO_TO_THREE = 'TWO_TO_THREE',
  TWO_TO_FIVE = 'TWO_TO_FIVE',
  THREE_TO_FOUR = 'THREE_TO_FOUR',
  THREE_TO_FIVE = 'THREE_TO_FIVE',
  FOUR_TO_FIVE = 'FOUR_TO_FIVE',
}

export enum EEventCategory {
  STANDALONE = 'STANDALONE',
  SERIES_WITH_THREE_PARTS = 'SERIES_WITH_THREE_PARTS',
  SERIES_WITH_TWO_PARTS = 'SERIES_WITH_TWO_PARTS',
}

export enum EEventPartType {
  PART_ONE = 'PART_ONE',
  PART_TWO = 'PART_TWO',
  PART_THREE = 'PART_THREE',
  STANDALONE = 'STANDALONE',
}

export enum EWorkshopsFilter {
  CHILD_CARE_PROVIDED = 'CHILD_CARE_PROVIDED',
  MEAL_PROVIDED = 'MEAL_PROVIDED',
}

export enum ERegistrantStatus {
  ACTIVE = 'ACTIVE',
  WAIT_LIST = 'WAIT_LIST',
}

export type TChildnameFormListItem = {
  name: string;
};

export type TEventChildcareRequirementsUI = {
  name: string;
  checked: boolean;
  value: number;
};

export type TEventChildcareRequirementsDB = {
  ageGroup: string;
  childCount: number;
};

export type TEventRegisterDataDB = {
  eventId: string;
  eventClassId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  childNames: string[];
  childcareRequirements: TEventChildcareRequirementsDB[];
  recaptchaResponse: string;
  hasReadyBinder?: boolean | null;
  userLanguage: EI18nLanguageDB;
  materialsLanguage?: ELanguage;
  customQuestionAnswer?: string;
  allowedTakePicture?: boolean | null;
  acceptedTerms: boolean;
  notificationDisabled?: boolean;
  additionalAdults?: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  }[];
};

export type TEventRegisterDataUI = {
  eventId: string;
  eventClassId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  childNames: TChildnameFormListItem[];
  childcareRequirements?: TEventChildcareRequirementsUI[];
  recaptchaResponse: string;
  hasReadyBinder: TYesNoOptionType;
  userLanguage: EI18nLanguageUI;
  materialsLanguage?: ELanguage;
  customQuestionAnswer?: string;
  allowedTakePicture: TYesNoOptionType;
  acceptedTerms: boolean;
  notificationDisabled?: boolean;
  additionalAdults?: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  }[];
};

export enum EAttendanceType {
  IN_PERSON = 'IN_PERSON',
  VIRTUAL = 'VIRTUAL',
}

export type TSessionsDB = {
  dateTime: string;
  isPassed: boolean;
  partType: EEventPartType;
};

export type TSessionsUi = {
  dateTime: string | null;
  isPassed: boolean;
  partType: EEventPartType;
};

export type TClassesDB = {
  ageGroup: EEventAgeGroup;
  language: ELanguage;
  sessions: TSessionsDB[];
  eventClassId: string;
};

export type TClassesUi = {
  ageGroup: EEventAgeGroup;
  language: ELanguage;
  sessions: TSessionsUi[];
  eventClassId: string;
};

export type TLanguageStatusItemUi = {
  sessions: TSessionsUi[];
  language: ELanguage;
};

export type TLanguagesStatusUi = {
  language: ELanguage;
  isPassed: boolean;
};

export type TPartInfoDB = {
  partType: EEventPartType;
  parts: TSessionsDB[];
};

export type TPartInfoUi = {
  partType: EEventPartType;
  isPassed: boolean;
  dateTime: string | null;
};

export type TEventEventsDB = {
  classes: TClassesDB[];
  childcareProvided: boolean;
  creationDate: string;
  foodProvided: boolean;
  locationAddress: string;
  locationName: string;
  eventCategory: EEventCategory;
  eventId: string;
  eventPhoto: string;
  eventType: EEventType;
  attendanceType: EAttendanceType;
};

export type TEventEventsUI = {
  classes: TClassesUi[];
  childcareProvided: boolean;
  creationDate: string;
  foodProvided: boolean;
  locationAddress: string;
  locationName: string;
  eventCategory: EEventCategory;
  eventId: string;
  eventPhoto: string;
  eventType: EEventType;
  ageGroups: string[];
  languagesStatus: TLanguagesStatusUi[];
  sessionsGrouped: TPartInfoUi[];
  attendanceType: EAttendanceType;
};

export type TEventDB = {
  hostName: string | null;
  eventEvents: TEventEventsDB[];
};

export type TEventUI = {
  hostName: string | null;
  eventEvents: TEventEventsUI[];
};

export type TPartsDB = {
  partType: EEventPartType;
  dateTime: string;
  isPassed: boolean;
};

export type TPartsUI = {
  partType: EEventPartType;
  date: { date: string; time: string };
  dateTimeString: string | null;
  isPassed: boolean;
};

export type TClassDB = {
  eventClassId: string;
  ageGroup: EEventAgeGroup;
  language: ELanguage;
  sessions: TPartsDB[];
};

export type TClassUI = {
  classId: string;
  date: string;
  ageGroup: EEventAgeGroup;
  language: ELanguage;
  sessions: TPartsUI[];
  isAllSessionsPassed: boolean;
};

export type TClassesByAgeGroupUI = [EEventAgeGroup, TClassUI];

export type TClassesByAgeGroupDB = {
  [key in EEventAgeGroup]: TClassDB;
};

export type TAgeGroupOptionsByLanguageUI = {
  [key in ELanguage]: TOption[];
};

export type TClassesGroupedByAgeUI = {
  ageGroup?: EEventAgeGroup;
  classes?: TClassesUi[];
};

export type TLocationCoordinatesDB = {
  latitude: number;
  longitude: number;
};

export type TLocationCoordinatesUI = {
  latitude: number;
  longitude: number;
};

export type TEventDetailDB = {
  childcareProvided: boolean;
  classes: TClassesDB[];
  creationDate: string;
  foodProvided: boolean;
  hostId: string;
  hostName: string;
  locationAddress: string;
  locationCoordinates: TLocationCoordinatesDB;
  locationAddressId: string;
  locationName: string;
  eventCategory: EEventCategory;
  eventDescription: string;
  eventId: string;
  eventPhoto: string;
  eventType: EEventType;
  eventTitle?: string;
  attendanceType: EAttendanceType;
};

export type TEventDetailUI = {
  childcareProvided: boolean;
  classes: TClassesGroupedByAgeUI[];
  creationDate: string;
  foodProvided: boolean;
  hostId: string;
  hostName: string;
  locationAddress: string;
  locationCoordinates: TLocationCoordinatesUI;
  locationAddressId: string;
  locationName: string;
  eventCategory: EEventCategory;
  eventDescription: string;
  eventId: string;
  eventPhoto: string;
  eventType: EEventType;
  eventTitle?: string;
  isAllClassesFinished: boolean;
  attendanceType: EAttendanceType;
};

export type TKitShippingAddressEditUI = {
  parentOrderId: string | null;
  address: TAddressTypesUI;
};

export type TKitShippingAddressEditDB = {
  parentOrderId: string | null;
  address: TAddressTypesDB;
};

export type TSubscribeDataUI = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  cities: string[];
  ageGroups: EEventAgeGroup[];
  languages: ELanguage[];
  recaptchaResponse: string;
};

export type TSubscribeDataDB = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  cities: string[];
  ageGroups: EEventAgeGroup[];
  languages: ELanguage[];
  recaptchaResponse: string;
};

export type TEventRegisterResponseUI = {
  status: ERegistrantStatus;
  registrantId: string;
};
export type TEventRegisterResponseDB = {
  status: ERegistrantStatus;
  registrantId: string;
};

export type TRegistrationFormDataDB = {
  childcareProvided: boolean;
  foodProvided?: boolean;
  customQuestion?: string;
  englishClasses: TClassesByAgeGroupDB;
  hostId: string;
  hostName: string;
  spanishClasses: TClassesByAgeGroupDB;
  parts: TPartsDB[];
  eventCategory: EEventCategory;
  eventId: string;
  eventType: EEventType;
  eventTitle?: string;
  locationName?: string;
  locationAddress?: string;
};

export type TRegistrationFormDataUI = {
  childcareProvided: boolean;
  foodProvided?: boolean;
  hostId: string;
  hostName: string;
  eventCategory: EEventCategory;
  eventId: string;
  eventType: EEventType;
  eventTitle?: string;
  englishClasses: TClassesByAgeGroupUI[];
  spanishClasses: TClassesByAgeGroupUI[];
  languageOptions: TOption[];
  parts: TPartsUI[];
  ageGroupOptions: TAgeGroupOptionsByLanguageUI;
  customQuestion?: string;
  isCCP: boolean;
  locationName?: string;
  locationAddress?: string;
};

export type TLightBoxUI = {
  id: string;
  firstSection: string;
  secondSection: string;
  picture: string;
  published: boolean;
};

export type TLightBoxDB = {
  id: string;
  firstSection: string;
  secondSection: string;
  picture: string;
  published: boolean;
};

export type TEventMultipleRegisterDataUI = {
  registrationDetails: TEventRegisterDataUI[];
};

export type TEventMultipleRegisterDataDB = {
  registrationDetails: TEventRegisterDataDB[];
};

export type TEventMultipleRegisterResponseUI = TEventRegisterResponseUI[];

export type TEventMultipleRegisterResponseDB = TEventRegisterResponseDB[];
